import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { clientConstants, clientModels } from '..';

export const useClientIdPaymentV2 = ({ id, ...args }: { id: number; page?: number | null; size?: number | null }) => {
  const { page, size } = args;

  return useQuery<Pagination<clientModels.IPaymentV2>>({
    queryKey: [clientConstants.queryKeys.CLIENT_ID_PAYMENT_V2, id, args],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: `/v1/client/${id}/payment/v2`,
          query: {
            page: page || 1,
            size: size || 10
          }
        })
      );

      const data: Pagination<clientModels.IPaymentV2> = res?.data?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map(item => ({
              ...item,
              createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp }),
              canceledDate: timeStampToDate({ date: item?.canceledDate, timeStamp: item?.canceledTimestamp }),
              contractCancelledDate: item?.contractCancelledDate
                ? timeStampToDate({
                    date: item?.contractCancelledDate,
                    timeStamp: item?.contractCancelledTimestamp
                  })
                : null
            }))
          }
        : res?.data?.data;
    }
  });
};
